import { Injectable } from '@angular/core';
import { CommunicationManagerService } from './communication-manager.service';
import { Observable } from 'rxjs';
import { ItemGroupComment } from '../models/cost-item';

@Injectable({
  providedIn: 'root',
})
export class ItemGroupCommentService {

  private routeBase = 'itemGroupComment';

  constructor(private cm: CommunicationManagerService) {}

  getItemGroupComments(projectId: string, itemGroupId: string) {
    return this.cm.get(`${this.routeBase}/all/${itemGroupId}`, [
      { headerName: 'projectId', headerValue: projectId },
    ]);
  }

  getAllItemGroupCommentsForProject(projectId: string): Observable<Array<ItemGroupComment>> {
    return this.cm.get(`${this.routeBase}/project`, [
      { headerName: 'projectId', headerValue: projectId },
    ]);
  }

  createItemGroupComment(
    projectId: string,
    departmentId: string,
    comment: string
  ) {
    return this.cm.postAndGetJson(
      `${this.routeBase}/${departmentId}`,
      { text: comment },
      [{ headerName: 'projectId', headerValue: projectId }]
    );
  }

  updateItemGroupComment(
    projectId: string,
    departmentId: string,
    commentId: string,
    comment: string
  ) {
    return this.cm.put(`${this.routeBase}/${commentId}`, { text: comment }, [
      { headerName: 'projectId', headerValue: projectId },
    ]);
  }

  deleteItemGroupComment(projectId: string, commentId: string) {
    return this.cm.delete(`${this.routeBase}/${commentId}`, [
      { headerName: 'projectId', headerValue: projectId },
    ]);
  }
}
